import * as React from 'react';
import { getFocusStyle, Icon, List, mergeStyleSets, Panel, PanelType, TextField } from '@fluentui/react';

import { useEffect, useState } from 'react';
import { IColonnaGenerale } from '../../../shared/interfaces';
import { useBoolean } from '@fluentui/react-hooks';
import CircleLoader from '../../Loader/CircleLoader/CircleLoader';
import { RootState } from '../../../store';
import { connect, ConnectedProps } from 'react-redux';
import { Text } from '@fluentui/react/lib/Text';



import { ITheme, useTheme } from '@fluentui/react/lib/Theme';
import colonneGeneraliService from '../../../services/colonneGenerali.service';
import { toastRef } from '../../Layout/Layout';
import { getLabelFromDataType } from '../../../shared/enums';

const generateStyles = (theme: ITheme) => {
    const { palette, semanticColors, fonts } = theme;
    return mergeStyleSets({
        itemCell: [
            getFocusStyle(theme, { inset: -1 }),
            {
                minHeight: 54,
                padding: 10,
                boxSizing: 'border-box',
                borderBottom: `1px solid ${semanticColors.bodyDivider}`,
                display: 'flex',
                selectors: {
                    '&:hover': { background: palette.neutralLight },
                },
            },
        ],
        itemContent: {
            marginLeft: 10,
            overflow: 'hidden',
            flexGrow: 1,
        },
        itemName: [
            fonts.mediumPlus,
            {
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
            },
        ],
        itemIndex: {
            fontSize: fonts.small.fontSize,
            color: palette.neutralTertiary,
            marginBottom: 10,
        },
        chevronCell: [
            getFocusStyle(theme, { inset: -1 }),
            {
                minHeight: 54,
                padding: 10,
                boxSizing: 'border-box',
                display: 'flex',
                selectors: {
                    '&:hover': { background: palette.neutralLight },
                },
                            cursor: 'pointer'

            },
        ],
        chevron: {
            alignSelf: 'center',
            color: palette.neutralTertiary,
            fontSize: fonts.large.fontSize,
            flexShrink: 0,
            marginRight: 10,

        },
    });
};

const mapState = (state: RootState) => ({
    currentAoo: state.sessionReducer.currentAoo
})

const mapDispatch = {

}

const connector = connect(mapState, mapDispatch);

type PropsFromRedux = ConnectedProps<typeof connector>

export interface AddEditAooProtocolViewManagerProps {
    loading?: boolean
    extraCssClass?: string
    panelHeaderText: string
    panelIsOpen: boolean
    internalColumnNames: string[];
    campiProtocolloInternalColumnNames: string[];
    onAddColumnToView: (aooProtocolViewManagerItem: IColonnaGenerale) => void
    onDismiss: () => void
}

type Props = AddEditAooProtocolViewManagerProps & PropsFromRedux

const AddEditAooProtocolViewManager: React.FunctionComponent<Props> = (props) => {
    const theme = useTheme();
    const classNames = React.useMemo(() => generateStyles(theme), [theme]);

    let loading = props.loading !== undefined ? props.loading : false;
    const [loadingPanel, { setTrue: showLoadingPanel, setFalse: dismissLoadingPanel }] = useBoolean(loading);

    const [originalItems, setOriginalItems] = useState<IColonnaGenerale[]>([]);
    const [items, setItems] = useState<IColonnaGenerale[]>([]);

    const [panelIsOpen, setPanelIsOpen] = useState<boolean>(props.panelIsOpen);


    useEffect(() => {
        if (props.panelIsOpen) {
            getColonneGenerali();
        }
        else {
            setOriginalItems([]);
            setItems([]);
        }
        setPanelIsOpen(props.panelIsOpen);
    }, [props.panelIsOpen]);

    useEffect(() => {
        if (originalItems.length > 0 && props.internalColumnNames && props.internalColumnNames.length > 0) {
            let filteredColumns = originalItems.filter(
                item => !props.internalColumnNames.includes(item.internalName)
            );
            if (props.campiProtocolloInternalColumnNames.length > 0) {
                filteredColumns = filteredColumns.filter(
                    item => props.campiProtocolloInternalColumnNames!.includes(item.internalName)
                );
            }

            setItems(filteredColumns);
        }

    }, [originalItems, props.internalColumnNames]);

    const getColonneGenerali = () => {
        showLoadingPanel();
        colonneGeneraliService.getColonneGenerali()
            .then(colonneGenerali => {
                let originalColumns = colonneGenerali.filter(
                    item => !props.internalColumnNames.includes(item.internalName)
                );
                if (props.campiProtocolloInternalColumnNames.length > 0) {
                    originalColumns = originalColumns.filter(
                        item => props.campiProtocolloInternalColumnNames!.includes(item.internalName)
                    );
                }

                setOriginalItems([...originalColumns]);
                setItems([...originalColumns]);

                dismissLoadingPanel();
            }).catch(error => {
                dismissLoadingPanel();
                if (!error.isErrorShown) {
                    toastRef.current?.show({
                        severity: 'error',
                        summary: 'Attenzione',
                        detail: `Non è stato possibile recuperare le informazioni`,
                        life: 5000
                    });
                }

            });

    }
    const addColumnToView = (item: IColonnaGenerale) => {
        props.onAddColumnToView(item);
    }

    const onRenderCell = React.useCallback(
        (item: IColonnaGenerale | undefined, index: number | undefined): JSX.Element => {
            if (item) {
                let typeValue = getLabelFromDataType(item.type);

                return (
                    <div className={classNames.itemCell} onDoubleClick={() => addColumnToView(item)} >
                        <div className={classNames.chevronCell} onClick={() => addColumnToView(item)} >
                            <Icon className={classNames.chevron} iconName={'ChevronLeft'}  />
                        </div>
                        <div className={classNames.itemContent}>
                            <div className={classNames.itemName}>{item.displayName}</div>
                            <div className={classNames.itemIndex}>{item.internalName}</div>
                            <div>{typeValue}</div>

                        </div>
                    </div>
                );
            }
            else return <React.Fragment></React.Fragment>
        },
        [classNames],
    );

    const onFilterChanged = (_: any, text: string | undefined): void => {
        if (text) {
            let filteredColumns = originalItems.filter(item => item.internalName.toLowerCase().indexOf(text.toLowerCase()) >= 0
                || item.displayName.toLowerCase().indexOf(text.toLowerCase()) >= 0 || item.type.toLowerCase().indexOf(text.toLowerCase()) >= 0);

            setItems(filteredColumns);
        }
        else {
            setItems(originalItems);
        }
    };


    return (
        <React.Fragment>
            <Panel
                key='addEditAooProtocolViewManagerPanel'
                isLightDismiss
                isOpen={panelIsOpen}
                type={PanelType.custom}
                customWidth={'600px'}
                headerText={props.panelHeaderText}
                focusTrapZoneProps={{
                    isClickableOutsideFocusTrap: true,
                    forceFocusInsideTrap: true,
                }}
                onDismiss={props.onDismiss}
                isFooterAtBottom={false}
            >

                <CircleLoader loaderClass='loader-large' loading={loadingPanel} />




                <div className={"flex flex-column position-relative overflow-hidden"}>
                    <TextField
                        label={'Filtra per Nome, InternalName o Tipo'}
                        // eslint-disable-next-line react/jsx-no-bind
                        onChange={onFilterChanged}
                    />

                    <div className={`position-relative my-scroll-div`}>

                        {items.length > 0 &&
                            <List items={items} onRenderCell={onRenderCell} />
                        }
                        {items.length === 0 &&
                            <div className={classNames.itemCell}>
                                <div>
                                    <Text variant={'mediumPlus'} block>
                                        Nessuna colonna trovata.
                                    </Text>
                                </div>
                            </div>
                        }
                    </div>
                </div>
            </Panel>

        </React.Fragment>

    );
}

export default connector(AddEditAooProtocolViewManager);
